import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import Select from 'react-select';

import {
  getIcon,
  formatThousands,
  getMonthCountInQuarterForDate,
} from '../../util';

import {
  getAllImperativeTasks
} from '../../util/data';

import {
  getDealCompletion
} from '../../util/dealScoring';

import {
  fetchAllClosedDeals
} from '../../actions/deals';

class WhyWeWinReport extends Component {

  state = {
    showingLegend: false,
  }

  componentDidMount(){
    this.props.fetchAllClosedDeals();
  }

  reportData(){

    const allDeals = this.props.deals;

    const DEFAULT_TASK_COUNTS = {
      closed: {
        complete: 0,
        incomplete: 0,
        failed: 0,
        total: 0
      },
      won: {
        complete: 0,
        incomplete: 0,
        failed: 0,
        total: 0
      },
      lost: {
        complete: 0,
        incomplete: 0,
        failed: 0,
        total: 0,
      },
    }

    const allConsideredImperativeTasks = _.filter(getAllImperativeTasks(), task => {
      //Don't consider "closing" imperative tasks, as these are pretty much always going to be complete on deals that actually close...
      return task.imperative !== '6';
    })

    const tasks = _.map(allConsideredImperativeTasks, task => {
      return {
        ...task,
        counts: _.cloneDeep(DEFAULT_TASK_COUNTS)
      }
    });

    // console.log('tasks: ', tasks);
    // console.log('allDeals: ', allDeals);

    _.each(allDeals, deal => {

      const {
        status,
        imperativeTasks
      } = deal;

      // console.log('imperativeTasks from DEAL: ', imperativeTasks);

      //don't use still open deals to inform data, or deals without any imperative data
      if(status === 'open' || !imperativeTasks){
        return;
      }

      _.each(tasks, task => {

        const taskStatusForDeal = imperativeTasks[task.id] ? imperativeTasks[task.id] : 'incomplete';

        if(status === 'won'){
          task.counts.won[taskStatusForDeal]++;
          task.counts.won.total++;
        }
        else if(status === 'lost'){
          task.counts.lost[taskStatusForDeal]++;
          task.counts.lost.total++;
        }

        task.counts.closed[taskStatusForDeal]++;
        task.counts.closed.total++;
      });
    });

    _.each(tasks, task => {

      const {
        won,
        lost,
        closed
      } = task.counts;

      task.winRatio = won.complete / closed.complete;
      // task.loseRatio = lost.complete / closed.complete;
      // task.winLoseRatio = won.complete / lost.complete;
      task.completeRatio = closed.complete / closed.total;
      task.winWhenNotCompleteRatio = (won.total - won.complete) / won.total;

      //task.overallScore = task.winLoseRatio;
      //task.overallScore = -1 * task.winWhenNotCompleteRatio;
      //value objectives that aren't completed as often more than those that are almost always completed ?

      task.overallScore = Math.ceil((Math.pow((task.winRatio - .5) * 275, 1.5) - Math.pow(task.winWhenNotCompleteRatio * 275, 1.2)) / 1);

      if(isNaN(task.overallScore) || task.overallScore < 0){
        task.overallScore = 0;
      }
      //task.overallScore = task.winLoseRatio;// * (1 - task.winWhenNotCompleteRatio);
    });

    //THIS should probably be a much more sophisticated function
    const rankedTasks = _.sortBy(tasks, task => {
      return -1 * task.overallScore;
    });

    // console.log('rankedTasks, ', rankedTasks);
    // console.log('averageScore, ', _.meanBy(tasks, 'overallScore'));

    return {
      rankedTasks,
      averageScore: _.meanBy(tasks, 'overallScore')
    };
  }

  renderReportTaskItem(task){

    const {
      id,
      text,
      imperative,
      winRatio,
      //loseRatio,
      //winLoseRatio,
      completeRatio,
      winWhenNotCompleteRatio,
      overallScore,
    } = task;

    const {
      averageScore
    } = this.reportData();

    if(overallScore === undefined || !averageScore || isNaN(overallScore) || isNaN(averageScore)){
      return null;
    }

    // console.log('overallScore: ', overallScore);
    // console.log('averageScore: ', averageScore);

    const winRatioPercent = Math.ceil(winRatio * 100);
    const winWhenNotCompleteRatioPercent = Math.ceil(winWhenNotCompleteRatio * 100);

    return (
      <div key={`task_${id}-report-item`} className="report-item report-item-row">
        <div className="label">{text}<br/><small>Imperative {imperative}</small></div>
        <div className="report-scoring">
          <div className="item-help" data-html={true} data-tip={`Your organization WINS ${winRatioPercent}% of deals that have this item completed.<br/>Overal score of ${overallScore} takes into account that fact that your organization is still able to win ${winWhenNotCompleteRatioPercent}% of deals when this item is not complete.`} data-for="predictive-pipeline-tooltip">{getIcon('info-bold')}<ReactTooltip id="predictive-pipeline-tooltip" /></div>
          <div className="item-scores">
            <div className={`score overall ${overallScore > averageScore ? 'above-average' : 'below-average'} ${overallScore <= 0 ? 'zero' : ''}`}>{overallScore}</div>
            <div className="score multi-line">WIN RATE: {winRatioPercent}%<br/>WIN RATE WITHOUT: {winWhenNotCompleteRatioPercent}%</div>
          </div>
        </div>
        {/*<p>Win Ratio: {winRatio}</p>
        <p>Complete Ratio: {completeRatio}</p>
        <p>Win When Not Complete Ratio: {winWhenNotCompleteRatio}</p>*/}
      </div>
    )
  }

  orgName(){
    return this.props.organization && this.props.organization.name ? this.props.organization.name : false;
  }

  renderReport(){

    const reportData = this.reportData();

    // console.log('reportData: ', reportData);

    return (
      <div className="report-sections">
        <div className="report-section">
          <h6>{this.orgName() ? `${this.orgName()} ` : ''}Key Deal Indicators<br/><span className="alpha">BETA</span></h6>
          <div className="report-items">
            {_.map(reportData.rankedTasks, this.renderReportTaskItem.bind(this))}
          </div>
        </div>
      </div>
    );
  }

  render(){
    const { showingLegend } = this.state;

    return (
      <div className="report why-we-win">
        <div className="content-wrapper">
          <div className="page-main-content">
            <div className="page-title">
              <h1>Why We Win</h1>
            </div>
            <div className="page-content">
              {this.renderReport()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    teams: state.teams.data,
    deals: state.deals.data,
    fetchingAllDeals: state.deals.loading,
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, { fetchAllClosedDeals })(WhyWeWinReport);



// WEBPACK FOOTER //
// ./src/components/reports/whyWeWin.js